<aside>
  <div
    class="flex justify-center items-center shadow border-b cursor-pointer h-16"
    (click)="redirectSite()"
  >
    <img class="w-[150px] h-[31.2px]" src="../../../assets/logos/logo.svg" alt="kc-logo" />
  </div>

  <nav>
    <ul class="space-y-2 mt-8 p-2 font-normal">
      @for (item of menuItems; track item.id) {
        <li class="text-[#A6ABC8] text-[12px]">
          <a
            [routerLink]="item.route"
            routerLinkActive="bg-primary/30 text-primary font-medium"
            class="flex items-center gap-3 px-4 py-2 rounded hover:bg-primary/10 transition"
          >
            <mat-icon [svgIcon]="item.icon"></mat-icon>
            <span>{{ item.label }}</span>
          </a>
        </li>
      }
    </ul>
  </nav>
</aside>
